import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Breadcrumb as CotopaxiBreadcrumb } from '@as/cotopaxi';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { LAST_VISITED_URL_KEY, PENULTIMATE_VISITED_URL_KEY, PENULT_CRUMB_URL_KEY, } from '../../constants/StorageKeysConstants';
import LocalStorageUtil from '../../util/LocalStorageUtil';
import { useAemConfig } from '@as-react/common-components';
const Breadcrumb = ({ crumbs = [], isBreadcrumbBackButtonEnabled }) => {
    const { pageInfo: { isPDPPage }, } = useAemConfig();
    const { t } = useTranslation(I18N_NAMESPACES.product);
    useEffect(() => {
        var _a, _b;
        const currentUrl = (_a = crumbs[crumbs.length - 1]) === null || _a === void 0 ? void 0 : _a.url;
        const penultimate = LocalStorageUtil.getJsonItem(LAST_VISITED_URL_KEY);
        LocalStorageUtil.setItem(LAST_VISITED_URL_KEY, currentUrl);
        LocalStorageUtil.setItem(PENULTIMATE_VISITED_URL_KEY, penultimate);
        if (crumbs.length > 1) {
            LocalStorageUtil.setItem(PENULT_CRUMB_URL_KEY, (_b = crumbs[crumbs.length - 2]) === null || _b === void 0 ? void 0 : _b.url);
        }
    }, [crumbs]);
    if (!crumbs || crumbs.length === 0)
        return null;
    const breadcrumbTranslations = {
        backTo: t(`${I18N_NAMESPACES.general}:breadcrumb.back.to`),
    };
    const goToPreviousPage = (e) => {
        e.preventDefault();
        const { history, location } = window;
        const destinationUrl = crumbs.length >= 2 && crumbs[crumbs.length - 2].url;
        if (LocalStorageUtil.getJsonItem(PENULTIMATE_VISITED_URL_KEY) === destinationUrl ||
            location.pathname.includes('product-compare')) {
            history.back();
        }
        else {
            location.href = destinationUrl.toString();
        }
    };
    return (_jsx(CotopaxiBreadcrumb, { analyticsAreaName: "navigation-breadcrumb", crumbs: crumbs, isBreadcrumbBackButtonEnabled: isBreadcrumbBackButtonEnabled, goToPreviousPage: goToPreviousPage, isPDP: isPDPPage, translations: breadcrumbTranslations }));
};
export default Breadcrumb;
